import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0058',
    ecrans: ['00-2']
});
